import { ResourceEdit, TextField, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import { Box, Stack } from "@mui/material"
import { ChangeEvent, useState } from "react"
import { TPageTrackingEdit } from "./types"
import "./styles.scss"
import { setDataInPath } from "../../../../utils/data"

export function PageTrackingEdit({ page, savePage }: TPageTrackingEdit) {
    const trackingData = page?.tracking || {}

    const { t } = useTranslation()

    function handleSeoFieldChangeTimeout(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const { name, value } = event.target

        const dataToUpdate = setDataInPath({ name, value, data: page.seo, merge: true })

        savePage({
            dataToUpdate,
            render: false
        })
    }

    const hasTrackingData = trackingData.google_analytics_id || trackingData.facebook_pixel_id

    return (
        <ResourceEdit
            className="pageTrackingEditResource"
            editable
            status={
                hasTrackingData ? "valid" : "empty"
            }
            title={t("pages-details-tracking-title")}
            desc={t("pages-details-tracking-desc")}
            support={hasTrackingData && <Stack direction="row" gap={6} >

            </Stack>}
            editableContent={<Stack gap={6}>
                <Stack gap={6}>
                    <TextField
                        name="tracking.google_analytics_id"
                        label={t("pages-details-tracking-google-analytics-title")}
                        placeholder={t("pages-details-tracking-google-analytics-placeholder")}
                        defaultValue={trackingData.google_analytics_id || ""}
                        iconName="Google18"
                        timeout={{
                            callback: handleSeoFieldChangeTimeout
                        }}
                    />
                    <TextField
                        className="facebook-pixel-id-field"
                        name="tracking.facebook_pixel_id"
                        label={t("pages-details-tracking-facebook-pixel-title")}
                        placeholder={t("pages-details-tracking-facebook-pixel-placeholder")}
                        defaultValue={trackingData.facebook_pixel_id || ""}
                        iconName="Facebook24"
                        timeout={{
                            callback: handleSeoFieldChangeTimeout
                        }}
                    />
                </Stack>
            </Stack>
            }
        />
    )
}

